import { useAuthStore } from '@/store/auth';

/** 心跳间隔：有交互时每 5 分钟问一次当前会话，顺带续会话、刷新菜单与按钮权限 */
const BEAT_INTERVAL_MS = 5 * 60 * 1000;

/** 交互窗口：最近这么久内有过操作才算「人在」；人走了不再发心跳，会话按空闲寿命照常过期 */
const ACTIVITY_WINDOW_MS = 5 * 60 * 1000;

/** 计入「有操作」的事件；滚动与触摸用 passive，不拦页面的滚动与手势 */
const ACTIVITY_EVENTS = ['pointerdown', 'keydown', 'wheel', 'scroll', 'touchstart'] as const;

let started = false;
/** 0 表示「还没见过任何操作」：页面刚打开、用户还没动时不该被当成有人 */
let lastActivityAt = 0;

/**
 * 起一条会话心跳：只在用户确实有操作时问服务端「我还登录着吗」。
 *
 * 为什么按交互而不是按页面开着：页面开着、人已经走了还照样续的话，空闲超时就永远不生效。
 * 这条心跳补的是「人在看页面、但页面本身不发请求」那一段——阅读、滚动都不产生业务请求，
 * 没有心跳就会被网关当成无操作踢下线。
 *
 * 成功时 {@link useAuthStore} 会整份落下服务端回的菜单与按钮权限，所以管理员改完权限之后，
 * 最迟一个心跳周期内界面就收敛到新权限，不用等用户重新登录。
 */
export function startSessionKeepAlive(): void {
  if (started) return;
  started = true;

  const markActive = () => {
    lastActivityAt = Date.now();
  };
  for (const name of ACTIVITY_EVENTS) {
    window.addEventListener(name, markActive, { passive: true });
  }

  window.setInterval(() => {
    if (Date.now() - lastActivityAt > ACTIVITY_WINDOW_MS) return;
    void useAuthStore.getState().refresh();
  }, BEAT_INTERVAL_MS);
}
